import PropTypes from 'prop-types'
import Courses, { COURSES_LANDING_QUERY } from '@layouts/courses'
import { fetchSSRData } from '@lib/ssr-fetch'
import initializeFeatures from '@lib/feature-flags/initializeFeatures'
import { isGolfFacilitiesDataSourceEnabled } from '@lib/feature-flags/facility-rollout'
import { loadPlayRouteData } from '@lib/golf-facilities/play-route-loader'

const PLAY_INDEX_LOG_PREFIX = '[play/index]'

export async function getServerSideProps({ req, res, query }) {
  const safeQuery = query ?? {}
  res.setHeader('Cache-Control', 'no-store')

  // Contentful landing content renders in BOTH flag states — never dropped.
  const result = await fetchSSRData({
    query: safeQuery,
    graphqlQuery: COURSES_LANDING_QUERY,
    variables: safeQuery,
    transform: (data) => data?.coursesLandingCollection?.items?.[0],
  })

  const featureFlags = await initializeFeatures({ req, res, query: safeQuery }).catch(() => null)

  if (!isGolfFacilitiesDataSourceEnabled(featureFlags)) {
    return {
      props: {
        query: safeQuery,
        ssrData: result.data ?? null,
        ...(result.error ? { error: result.error } : {}),
      },
    }
  }

  // Flag on: also server-render the states strip from the golf-facilities SDK.
  // On any strip error use [] so the client does not fall back to Algolia.
  let ssrStatesData = []
  try {
    const statesOutcome = await loadPlayRouteData({
      call: (client) => client.facilities.states(),
      logPrefix: PLAY_INDEX_LOG_PREFIX,
    })
    ssrStatesData = statesOutcome.notFound ? [] : (statesOutcome.data ?? [])
  } catch {
    ssrStatesData = []
  }

  return {
    props: {
      query: safeQuery,
      ssrData: result.data ?? null,
      ssrStatesData,
      ...(result.error ? { error: result.error } : {}),
    },
  }
}

function PlayPage(props) {
  return <Courses {...props} />
}

PlayPage.propTypes = {
  query: PropTypes.object,
  ssrData: PropTypes.object,
  ssrStatesData: PropTypes.array,
}

export default PlayPage
